import React from 'react';

const SIZE_CLASS = {
  lg: 'duo-modal--lg',
  xl: 'duo-modal--xl',
};

const DuoModal = ({ title, onClose, children, footer, size }) => {
  return (
    <div className="duo-overlay" onClick={onClose} role="presentation">
      <div
        className={`duo-modal ${SIZE_CLASS[size] || ''}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="duo-modal-title"
      >
        <div className="duo-modal__head">
          <h2 id="duo-modal-title" className="duo-modal__title">
            {title}
          </h2>
          <button type="button" className="duo-modal__close" onClick={onClose} aria-label="Fermer">
            ×
          </button>
        </div>
        <div className="duo-modal__body">{children}</div>
        {footer ? <div className="duo-modal__footer">{footer}</div> : null}
      </div>
    </div>
  );
};

export default DuoModal;
